import _ from 'lodash';

const nullOrUndefined = (value) => {
    return value === null || value === undefined || _.isEqual(value, {}); 
}

export default nullOrUndefined; 